// extracted by mini-css-extract-plugin
module.exports = {"spacer":"Fields_spacer__ElmBu"};